<template>
    <div v-if="canShow('气血津液辨证') && info && info.tizhi_qixuejinye">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">气血津液辨证</div>
        </div>
        <div class="assessment">
            <div class="sick-dosc">
                <div id="y_blood" class="balance-meter-status"></div>
                <div v-for="(item, index) in info.tizhi_qixuejinye" :key="index">
                    <div class="flex inner-name">
                        <div class="flex-1">{{ index }}</div>
                        <div>{{ item.fenshu }}分<span>(最高10分)</span></div>
                    </div>
                    <div>{{ item.desc }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin } from '../helpers';
import { drawRadar } from '../chart';

// page===0 是整页显示，page===5 是单独翻到气血津液辨证这一屏
const VISIBLE_PAGES = [0, 5];

export default {
    name: 'ReportQixuejinye',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info', 'page']),
        qxjy() {
            return this.info && this.info.tizhi_qixuejinye;
        },
        radarVisible() {
            return VISIBLE_PAGES.indexOf(this.page) !== -1;
        }
    },
    mounted() {
        this.scheduleRenderRadar();
    },
    watch: {
        radarVisible(val) {
            if (val) this.scheduleRenderRadar();
        },
        qxjy() {
            this.scheduleRenderRadar();
        }
    },
    methods: {
        // 推迟到下一个宏任务，确保 .new-box.y4 已 display:block
        scheduleRenderRadar() {
            if (!this.radarVisible) return;
            setTimeout(() => this.renderRadar(), 1);
        },
        renderRadar() {
            if (!this.qxjy) return;
            if (!this.canShow('气血津液辨证')) return;
            const q = this.qxjy;
            if (!q['气血充盈度'] || !q['气血运行度'] || !q['津液代谢度'] || !q['津液濡润度']) return;
            drawRadar('y_blood', [
                q['气血充盈度'].fenshu,
                q['气血运行度'].fenshu,
                q['津液代谢度'].fenshu,
                q['津液濡润度'].fenshu
            ]);
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Qixuejinye.scss';
</style>
